import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { Box, Content } from './components'
import PropTypes from 'prop-types';

export const ScrollBox = forwardRef((props, ref) => {

  const listRef = useRef(null);

  useImperativeHandle(ref, () => ({
    scrollToTop() {
      if (listRef && listRef.current) {
        listRef.current.scrollTo({ top: 0, behavior: 'smooth' })
      }
    },
    scrollToBottom() {
      if (listRef && listRef.current) {
        listRef.current.scrollTo({ top: 1500, behavior: 'smooth' });
      }
    },
  }));

  const handleScroll = (event) => {
    const target = event.target;
    if (target.scrollTop && target.scrollTop < target.clientHeight) {
      props.onScroll && props.onScroll(target.scrollTop)
    }
    if (target.scrollHeight - target.scrollTop === target.clientHeight) {
      props.onReachEnd && props.onReachEnd();
    }
  }

  return (
    <Box ref={listRef} onScroll={(event) => handleScroll(event)} onTouchMove={(event) => props.stopPropagation ? event.stopPropagation() : () => { }}>
      <Content>
        {props.children}
      </Content>
    </Box>
  )
})

ScrollBox.propTypes = {
  children: PropTypes.node,
  onReachEnd: PropTypes.func,
  onScroll: PropTypes.func,
  stopPropagation: PropTypes.bool,
};